<div class="lock-overlay" *ngIf="visible">
  <div class="lock-card">
    <div class="lock-logo">
      <img src="assets/logo.png" alt="Logo" />
    </div>

    <h2 class="lock-title">Relace uzamčena</h2>
    <p class="lock-subtitle">Pro pokračování zadejte své heslo.</p>

    <form (ngSubmit)="unlock()">
      <div class="lock-field">
        <label>E-mail</label>
        <input type="email" pInputText [value]="email" readonly class="w-full lock-email" />
      </div>

      <div class="lock-field">
        <label for="lock-pass">Heslo</label>
        <input id="lock-pass" type="password" pInputText [(ngModel)]="password" name="password"
               autocomplete="current-password" class="w-full" autofocus
               placeholder="Zadejte heslo" />
      </div>

      <small class="lock-error" *ngIf="errorMsg">{{ errorMsg }}</small>

      <button pButton type="submit" class="w-full mt-3"
              [disabled]="!password || loading"
              [label]="loading ? 'Odemykám…' : 'Odemknout'"
              [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-lock-open'"></button>
    </form>

    <button pButton type="button" class="p-button-text p-button-sm w-full mt-2 lock-switch"
            label="Přihlásit se jako jiný uživatel" icon="pi pi-user"
            (click)="logoutFull()"></button>
  </div>
</div>
